export const PERSIST_KEYS = {
  AUTH: 'treneo:auth',
  USER: 'treneo:user'
} as const;

export type PersistKey = (typeof PERSIST_KEYS)[keyof typeof PERSIST_KEYS];
